import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { ImageVersions } from "@domain/media/dtos";
import { Media } from "@domain/media/media";
import { mobile } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Gallery } from "./gallery";
import { ZoomedImageView } from "./imageView";
import { ZoomedPdfViewer } from "@ui/components/media/pdf/zoomedPdfViewer";
import { TooshareVideoPlayer } from "./tooshareVideoPlayer";

interface ZoomedAssetProps {
	asset: Media;
	onClose: () => void;
}
export const ZoomedAsset: React.FC<ZoomedAssetProps> = ({ asset, onClose }) => {
	return asset.mimeType === "application/pdf" ? (
		<ZoomedPdfViewer source={asset.url} onClose={onClose} />
	) : (
		<Gallery
			items={[asset]}
			onClose={onClose}
			renderItem={(asset) => {
				if (asset.mimeType.startsWith("image")) {
					return <ZoomedImageView fullSize image={asset} imageVersion={ImageVersions.LARGE} zoomDisabled />;
				}
				if (asset.mimeType.startsWith("video/")) {
					return <ZoomedTooshareVideoPlayer asset={asset} />;
				}
				if (asset.mimeType.startsWith("audio/")) {
					return <audio controls src={asset.url} />;
				}
				return <ErrorMedia>{I18n.t("asset_manager.gallery.error")}</ErrorMedia>;
			}}
		/>
	);
};
const ZoomedTooshareVideoPlayer = styled(TooshareVideoPlayer)`
	width: 50vw;
	@media ${mobile} {
		width: 90vw;
	}
`;

const ErrorMedia = styled(RoundedBlock)`
	padding: 20px;
`;
